import { httpCall,httpCallNoAuth,httpFormCall, httpLoginCall } from "../../Core/HttpService"
import { API_URL } from "../../common/Constants"

export const loadPostEventsDetails = params => {
    return httpCallNoAuth({
        url: API_URL.POST_EVENTS,
        method: "post",
        data: params
    }).then(response => {
        return response;
    });
};




export const loadEventGallery = params => {
    return httpCallNoAuth({
        url: API_URL.POST_EVENTS_GALLERY,
        method: "post",
        data: params
    }).then(response => {
        return response;
    });
};

export const sendEmail = params => {
    return httpCallNoAuth({
        url: API_URL.SEND_EMAIL,
        method: "post",
        data: params
    }).then(response => {
        return response;
    });
};


export const loadUpdate = params => {
    return httpCallNoAuth({
        url: API_URL.SUNDAY_UPDATES,
        method: "post",
        data: params
    }).then(response => {
        return response;
    });
};


export const loadYouTubeLinks = (params) => {
    return httpCallNoAuth({
        url: "/admin/getlinklist",
        method: "post",
        data: params,
    }).then((response) => {
        return response;
    });
};



export const insertGiftAidData = (params) => {
    return httpCall({
        url: "/admin/giftaid",
        method: "post",
        data: params,
    }).then((response) => {
        return response;
    });
};



export const getPaymentHash = (params) => {
    return httpCall({
        url: "/admin/getPaymentHash",
        method: "post",
        data: params,
    }).then((response) => {
        return response;
    });
};


export const insertVBSRegisterDetails = (params) => {
    return httpCall({
        url: "/admin/addVBSRegistration",
        method: "post",
        data: params,
    }).then((response) => {
        return response;
    });
};

